import { AdminReportCountersStore } from './admin-reports-counters-store';
import { AdminReportsAuditLogsStore } from './admin-reports-audit-logs-store';

export function setupRepositories(storeBuilder) {
  storeBuilder.addRepository(new AdminReportCountersStore());
  storeBuilder.addRepository(new AdminReportsAuditLogsStore());
}
